!(function() {
  'use strict';
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function t(
    t,
    e,
    s,
    i
  ) {
    var n,
      o = arguments.length,
      r = o < 3 ? e : null === i ? (i = Object.getOwnPropertyDescriptor(e, s)) : i;
    if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate) r = Reflect.decorate(t, e, s, i);
    else for (var l = t.length - 1; l >= 0; l--) (n = t[l]) && (r = (o < 3 ? n(r) : o > 3 ? n(e, s, r) : n(e, s)) || r);
    return o > 3 && r && Object.defineProperty(e, s, r), r;
  }
  function e(t, e) {
    if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata) return Reflect.metadata(t, e);
  }
  /**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ const s = window,
    i =
      s.ShadowRoot &&
      (void 0 === s.ShadyCSS || s.ShadyCSS.nativeShadow) &&
      'adoptedStyleSheets' in Document.prototype &&
      'replace' in CSSStyleSheet.prototype,
    n = Symbol(),
    o = new WeakMap();
  class r {
    constructor(t, e, s) {
      if (((this._$cssResult$ = !0), s !== n))
        throw Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
      (this.cssText = t), (this.t = e);
    }
    get styleSheet() {
      let t = this.o;
      const e = this.t;
      if (i && void 0 === t) {
        const s = void 0 !== e && 1 === e.length;
        s && (t = o.get(e)),
          void 0 === t && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), s && o.set(e, t));
      }
      return t;
    }
    toString() {
      return this.cssText;
    }
  }
  const l = i
    ? (t) => t
    : (t) =>
        t instanceof CSSStyleSheet
          ? ((t) => {
              let e = '';
              for (const s of t.cssRules) e += s.cssText;
              return ((t) => new r('string' == typeof t ? t : t + '', void 0, n))(e);
            })(t)
          : t;
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var h;
  const a = window,
    c = a.trustedTypes,
    d = c ? c.emptyScript : '',
    u = a.reactiveElementPolyfillSupport,
    p = {
      toAttribute(t, e) {
        switch (e) {
          case Boolean:
            t = t ? d : null;
            break;
          case Object:
          case Array:
            t = null == t ? t : JSON.stringify(t);
        }
        return t;
      },
      fromAttribute(t, e) {
        let s = t;
        switch (e) {
          case Boolean:
            s = null !== t;
            break;
          case Number:
            s = null === t ? null : Number(t);
            break;
          case Object:
          case Array:
            try {
              s = JSON.parse(t);
            } catch (t) {
              s = null;
            }
        }
        return s;
      }
    },
    v = (t, e) => e !== t && (e == e || t == t),
    $ = { attribute: !0, type: String, converter: p, reflect: !1, hasChanged: v };
  class _ extends HTMLElement {
    constructor() {
      super(),
        (this._$Ei = new Map()),
        (this.isUpdatePending = !1),
        (this.hasUpdated = !1),
        (this._$El = null),
        this.u();
    }
    static addInitializer(t) {
      var e;
      this.finalize(), (null !== (e = this.h) && void 0 !== e ? e : (this.h = [])).push(t);
    }
    static get observedAttributes() {
      this.finalize();
      const t = [];
      return (
        this.elementProperties.forEach((e, s) => {
          const i = this._$Ep(s, e);
          void 0 !== i && (this._$Ev.set(i, s), t.push(i));
        }),
        t
      );
    }
    static createProperty(t, e = $) {
      if (
        (e.state && (e.attribute = !1),
        this.finalize(),
        this.elementProperties.set(t, e),
        !e.noAccessor && !this.prototype.hasOwnProperty(t))
      ) {
        const s = 'symbol' == typeof t ? Symbol() : '__' + t,
          i = this.getPropertyDescriptor(t, s, e);
        void 0 !== i && Object.defineProperty(this.prototype, t, i);
      }
    }
    static getPropertyDescriptor(t, e, s) {
      return {
        get() {
          return this[e];
        },
        set(i) {
          const n = this[t];
          (this[e] = i), this.requestUpdate(t, n, s);
        },
        configurable: !0,
        enumerable: !0
      };
    }
    static getPropertyOptions(t) {
      return this.elementProperties.get(t) || $;
    }
    static finalize() {
      if (this.hasOwnProperty('finalized')) return !1;
      this.finalized = !0;
      const t = Object.getPrototypeOf(this);
      if (
        (t.finalize(),
        void 0 !== t.h && (this.h = [...t.h]),
        (this.elementProperties = new Map(t.elementProperties)),
        (this._$Ev = new Map()),
        this.hasOwnProperty('properties'))
      ) {
        const t = this.properties,
          e = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
        for (const s of e) this.createProperty(s, t[s]);
      }
      return (this.elementStyles = this.finalizeStyles(this.styles)), !0;
    }
    static finalizeStyles(t) {
      const e = [];
      if (Array.isArray(t)) {
        const s = new Set(t.flat(1 / 0).reverse());
        for (const t of s) e.unshift(l(t));
      } else void 0 !== t && e.push(l(t));
      return e;
    }
    static _$Ep(t, e) {
      const s = e.attribute;
      return !1 === s ? void 0 : 'string' == typeof s ? s : 'string' == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
      var t;
      (this._$E_ = new Promise((t) => (this.enableUpdating = t))),
        (this._$AL = new Map()),
        this._$Eg(),
        this.requestUpdate(),
        null === (t = this.constructor.h) || void 0 === t || t.forEach((t) => t(this));
    }
    addController(t) {
      var e, s;
      (null !== (e = this._$ES) && void 0 !== e ? e : (this._$ES = [])).push(t),
        void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
      var e;
      null === (e = this._$ES) || void 0 === e || e.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
      this.constructor.elementProperties.forEach((t, e) => {
        this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
      });
    }
    createRenderRoot() {
      var t;
      const e =
        null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
      return (
        ((t, e) => {
          i
            ? (t.adoptedStyleSheets = e.map((t) => (t instanceof CSSStyleSheet ? t : t.styleSheet)))
            : e.forEach((e) => {
                const i = document.createElement('style'),
                  n = s.litNonce;
                void 0 !== n && i.setAttribute('nonce', n), (i.textContent = e.cssText), t.appendChild(i);
              });
        })(e, this.constructor.elementStyles),
        e
      );
    }
    connectedCallback() {
      var t;
      void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()),
        this.enableUpdating(!0),
        null === (t = this._$ES) ||
          void 0 === t ||
          t.forEach((t) => {
            var e;
            return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
          });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
      var t;
      null === (t = this._$ES) ||
        void 0 === t ||
        t.forEach((t) => {
          var e;
          return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
        });
    }
    attributeChangedCallback(t, e, s) {
      this._$AK(t, s);
    }
    _$EO(t, e, s = $) {
      var i;
      const n = this.constructor._$Ep(t, s);
      if (void 0 !== n && !0 === s.reflect) {
        const o = (void 0 !== (null === (i = s.converter) || void 0 === i ? void 0 : i.toAttribute)
          ? s.converter
          : p
        ).toAttribute(e, s.type);
        (this._$El = t), null == o ? this.removeAttribute(n) : this.setAttribute(n, o), (this._$El = null);
      }
    }
    _$AK(t, e) {
      var s;
      const i = this.constructor,
        n = i._$Ev.get(t);
      if (void 0 !== n && this._$El !== n) {
        const t = i.getPropertyOptions(n),
          o =
            'function' == typeof t.converter
              ? { fromAttribute: t.converter }
              : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute)
              ? t.converter
              : p;
        (this._$El = n), (this[n] = o.fromAttribute(e, t.type)), (this._$El = null);
      }
    }
    requestUpdate(t, e, s) {
      let i = !0;
      void 0 !== t &&
        (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || v)(this[t], e)
          ? (this._$AL.has(t) || this._$AL.set(t, e),
            !0 === s.reflect &&
              this._$El !== t &&
              (void 0 === this._$EC && (this._$EC = new Map()), this._$EC.set(t, s)))
          : (i = !1)),
        !this.isUpdatePending && i && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
      this.isUpdatePending = !0;
      try {
        await this._$E_;
      } catch (t) {
        Promise.reject(t);
      }
      const t = this.scheduleUpdate();
      return null != t && (await t), !this.isUpdatePending;
    }
    scheduleUpdate() {
      return this.performUpdate();
    }
    performUpdate() {
      var t;
      if (!this.isUpdatePending) return;
      this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, e) => (this[e] = t)), (this._$Ei = void 0));
      let e = !1;
      const s = this._$AL;
      try {
        (e = this.shouldUpdate(s)),
          e
            ? (this.willUpdate(s),
              null === (t = this._$ES) ||
                void 0 === t ||
                t.forEach((t) => {
                  var e;
                  return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                }),
              this.update(s))
            : this._$Ek();
      } catch (t) {
        throw ((e = !1), this._$Ek(), t);
      }
      e && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
      var e;
      null === (e = this._$ES) ||
        void 0 === e ||
        e.forEach((t) => {
          var e;
          return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
        }),
        this.hasUpdated || ((this.hasUpdated = !0), this.firstUpdated(t)),
        this.updated(t);
    }
    _$Ek() {
      (this._$AL = new Map()), (this.isUpdatePending = !1);
    }
    get updateComplete() {
      return this.getUpdateComplete();
    }
    getUpdateComplete() {
      return this._$E_;
    }
    shouldUpdate(t) {
      return !0;
    }
    update(t) {
      void 0 !== this._$EC && (this._$EC.forEach((t, e) => this._$EO(e, this[e], t)), (this._$EC = void 0)),
        this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
  }
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var f;
  (_.finalized = !0),
    (_.elementProperties = new Map()),
    (_.elementStyles = []),
    (_.shadowRootOptions = { mode: 'open' }),
    null == u || u({ ReactiveElement: _ }),
    (null !== (h = a.reactiveElementVersions) && void 0 !== h ? h : (a.reactiveElementVersions = [])).push('1.6.1');
  const y = window,
    g = y.trustedTypes,
    A = g ? g.createPolicy('lit-html', { createHTML: (t) => t }) : void 0,
    m = `lit$${(Math.random() + '').slice(9)}$`,
    b = '?' + m,
    S = `<${b}>`,
    E = document,
    w = () => E.createComment(''),
    C = (t) => null === t || ('object' != typeof t && 'function' != typeof t),
    U = Array.isArray,
    P = '[ \t\n\f\r]',
    x = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
    k = /-->/g,
    H = />/g,
    N = RegExp(`>|${P}(?:([^\\s"'>=/]+)(${P}*=${P}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, 'g'),
    O = /'/g,
    T = /"/g,
    R = /^(?:script|style|textarea|title)$/i,
    M = ((t) => (e, ...s) => ({ _$litType$: t, strings: e, values: s }))(1),
    j = Symbol.for('lit-noChange'),
    z = Symbol.for('lit-nothing'),
    L = new WeakMap(),
    B = E.createTreeWalker(E, 129, null, !1),
    D = (t, e) => {
      const s = t.length - 1,
        i = [];
      let n,
        o = 2 === e ? '<svg>' : '',
        r = x;
      for (let e = 0; e < s; e++) {
        const s = t[e];
        let l,
          h,
          a = -1,
          c = 0;
        for (; c < s.length && ((r.lastIndex = c), (h = r.exec(s)), null !== h); )
          (c = r.lastIndex),
            r === x
              ? '!--' === h[1]
                ? (r = k)
                : void 0 !== h[1]
                ? (r = H)
                : void 0 !== h[2]
                ? (R.test(h[2]) && (n = RegExp('</' + h[2], 'g')), (r = N))
                : void 0 !== h[3] && (r = N)
              : r === N
              ? '>' === h[0]
                ? ((r = null != n ? n : x), (a = -1))
                : void 0 === h[1]
                ? (a = -2)
                : ((a = r.lastIndex - h[2].length), (l = h[1]), (r = void 0 === h[3] ? N : '"' === h[3] ? T : O))
              : r === T || r === O
              ? (r = N)
              : r === k || r === H
              ? (r = x)
              : ((r = N), (n = void 0));
        const d = r === N && t[e + 1].startsWith('/>') ? ' ' : '';
        o +=
          r === x
            ? s + S
            : a >= 0
            ? (i.push(l), s.slice(0, a) + '$lit$' + s.slice(a) + m + d)
            : s + m + (-2 === a ? (i.push(void 0), e) : d);
      }
      const l = o + (t[s] || '<?>') + (2 === e ? '</svg>' : '');
      if (!Array.isArray(t) || !t.hasOwnProperty('raw')) throw Error('invalid template strings array');
      return [void 0 !== A ? A.createHTML(l) : l, i];
    };
  class I {
    constructor({ strings: t, _$litType$: e }, s) {
      let i;
      this.parts = [];
      let n = 0,
        o = 0;
      const r = t.length - 1,
        l = this.parts,
        [h, a] = D(t, e);
      if (((this.el = I.createElement(h, s)), (B.currentNode = this.el.content), 2 === e)) {
        const t = this.el.content,
          e = t.firstChild;
        e.remove(), t.append(...e.childNodes);
      }
      for (; null !== (i = B.nextNode()) && l.length < r; ) {
        if (1 === i.nodeType) {
          if (i.hasAttributes()) {
            const t = [];
            for (const e of i.getAttributeNames())
              if (e.endsWith('$lit$') || e.startsWith(m)) {
                const s = a[o++];
                if ((t.push(e), void 0 !== s)) {
                  const t = i.getAttribute(s.toLowerCase() + '$lit$').split(m),
                    e = /([.?@])?(.*)/.exec(s);
                  l.push({
                    type: 1,
                    index: n,
                    name: e[2],
                    strings: t,
                    ctor: '.' === e[1] ? J : '?' === e[1] ? F : '@' === e[1] ? G : K
                  });
                } else l.push({ type: 6, index: n });
              }
            for (const e of t) i.removeAttribute(e);
          }
          if (R.test(i.tagName)) {
            const t = i.textContent.split(m),
              e = t.length - 1;
            if (e > 0) {
              i.textContent = g ? g.emptyScript : '';
              for (let s = 0; s < e; s++) i.append(t[s], w()), B.nextNode(), l.push({ type: 2, index: ++n });
              i.append(t[e], w());
            }
          }
        } else if (8 === i.nodeType)
          if (i.data === b) l.push({ type: 2, index: n });
          else {
            let t = -1;
            for (; -1 !== (t = i.data.indexOf(m, t + 1)); ) l.push({ type: 7, index: n }), (t += m.length - 1);
          }
        n++;
      }
    }
    static createElement(t, e) {
      const s = E.createElement('template');
      return (s.innerHTML = t), s;
    }
  }
  function V(t, e, s = t, i) {
    var n, o, r, l;
    if (e === j) return e;
    let h = void 0 !== i ? (null === (n = s._$Co) || void 0 === n ? void 0 : n[i]) : s._$Cl;
    const a = C(e) ? void 0 : e._$litDirective$;
    return (
      (null == h ? void 0 : h.constructor) !== a &&
        (null === (o = null == h ? void 0 : h._$AO) || void 0 === o || o.call(h, !1),
        void 0 === a ? (h = void 0) : ((h = new a(t)), h._$AT(t, s, i)),
        void 0 !== i ? ((null !== (r = (l = s)._$Co) && void 0 !== r ? r : (l._$Co = []))[i] = h) : (s._$Cl = h)),
      void 0 !== h && (e = V(t, h._$AS(t, e.values), h, i)),
      e
    );
  }
  class q {
    constructor(t, e) {
      (this._$AV = []), (this._$AN = void 0), (this._$AD = t), (this._$AM = e);
    }
    get parentNode() {
      return this._$AM.parentNode;
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    u(t) {
      var e;
      const {
          el: { content: s },
          parts: i
        } = this._$AD,
        n = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : E).importNode(s, !0);
      B.currentNode = n;
      let o = B.nextNode(),
        r = 0,
        l = 0,
        h = i[0];
      for (; void 0 !== h; ) {
        if (r === h.index) {
          let e;
          2 === h.type
            ? (e = new W(o, o.nextSibling, this, t))
            : 1 === h.type
            ? (e = new h.ctor(o, h.name, h.strings, this, t))
            : 6 === h.type && (e = new Q(o, this, t)),
            this._$AV.push(e),
            (h = i[++l]);
        }
        r !== (null == h ? void 0 : h.index) && ((o = B.nextNode()), r++);
      }
      return (B.currentNode = E), n;
    }
    v(t) {
      let e = 0;
      for (const s of this._$AV)
        void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, e), (e += s.strings.length - 2)) : s._$AI(t[e])), e++;
    }
  }
  class W {
    constructor(t, e, s, i) {
      var n;
      (this.type = 2),
        (this._$AH = z),
        (this._$AN = void 0),
        (this._$AA = t),
        (this._$AB = e),
        (this._$AM = s),
        (this.options = i),
        (this._$Cp = null === (n = null == i ? void 0 : i.isConnected) || void 0 === n || n);
    }
    get _$AU() {
      var t, e;
      return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cp;
    }
    get parentNode() {
      let t = this._$AA.parentNode;
      const e = this._$AM;
      return void 0 !== e && 11 === (null == t ? void 0 : t.nodeType) && (t = e.parentNode), t;
    }
    get startNode() {
      return this._$AA;
    }
    get endNode() {
      return this._$AB;
    }
    _$AI(t, e = this) {
      (t = V(this, t, e)),
        C(t)
          ? t === z || null == t || '' === t
            ? (this._$AH !== z && this._$AR(), (this._$AH = z))
            : t !== this._$AH && t !== j && this._(t)
          : void 0 !== t._$litType$
          ? this.g(t)
          : void 0 !== t.nodeType
          ? this.$(t)
          : ((t) => U(t) || 'function' == typeof (null == t ? void 0 : t[Symbol.iterator]))(t)
          ? this.T(t)
          : this._(t);
    }
    k(t) {
      return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
      this._$AH !== t && (this._$AR(), (this._$AH = this.k(t)));
    }
    _(t) {
      this._$AH !== z && C(this._$AH) ? (this._$AA.nextSibling.data = t) : this.$(E.createTextNode(t)), (this._$AH = t);
    }
    g(t) {
      var e;
      const { values: s, _$litType$: i } = t,
        n = 'number' == typeof i ? this._$AC(t) : (void 0 === i.el && (i.el = I.createElement(i.h, this.options)), i);
      if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === n) this._$AH.v(s);
      else {
        const t = new q(n, this),
          e = t.u(this.options);
        t.v(s), this.$(e), (this._$AH = t);
      }
    }
    _$AC(t) {
      let e = L.get(t.strings);
      return void 0 === e && L.set(t.strings, (e = new I(t))), e;
    }
    T(t) {
      U(this._$AH) || ((this._$AH = []), this._$AR());
      const e = this._$AH;
      let s,
        i = 0;
      for (const n of t)
        i === e.length ? e.push((s = new W(this.k(w()), this.k(w()), this, this.options))) : (s = e[i]), s._$AI(n), i++;
      i < e.length && (this._$AR(s && s._$AB.nextSibling, i), (e.length = i));
    }
    _$AR(t = this._$AA.nextSibling, e) {
      var s;
      for (null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, e); t && t !== this._$AB; ) {
        const e = t.nextSibling;
        t.remove(), (t = e);
      }
    }
    setConnected(t) {
      var e;
      void 0 === this._$AM && ((this._$Cp = t), null === (e = this._$AP) || void 0 === e || e.call(this, t));
    }
  }
  class K {
    constructor(t, e, s, i, n) {
      (this.type = 1),
        (this._$AH = z),
        (this._$AN = void 0),
        (this.element = t),
        (this.name = e),
        (this._$AM = i),
        (this.options = n),
        s.length > 2 || '' !== s[0] || '' !== s[1]
          ? ((this._$AH = Array(s.length - 1).fill(new String())), (this.strings = s))
          : (this._$AH = z);
    }
    get tagName() {
      return this.element.tagName;
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    _$AI(t, e = this, s, i) {
      const n = this.strings;
      let o = !1;
      if (void 0 === n) (t = V(this, t, e, 0)), (o = !C(t) || (t !== this._$AH && t !== j)), o && (this._$AH = t);
      else {
        const i = t;
        let r, l;
        for (t = n[0], r = 0; r < n.length - 1; r++)
          (l = V(this, i[s + r], e, r)),
            l === j && (l = this._$AH[r]),
            o || (o = !C(l) || l !== this._$AH[r]),
            l === z ? (t = z) : t !== z && (t += (null != l ? l : '') + n[r + 1]),
            (this._$AH[r] = l);
      }
      o && !i && this.j(t);
    }
    j(t) {
      t === z ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : '');
    }
  }
  class J extends K {
    constructor() {
      super(...arguments), (this.type = 3);
    }
    j(t) {
      this.element[this.name] = t === z ? void 0 : t;
    }
  }
  const Z = g ? g.emptyScript : '';
  class F extends K {
    constructor() {
      super(...arguments), (this.type = 4);
    }
    j(t) {
      t && t !== z ? this.element.setAttribute(this.name, Z) : this.element.removeAttribute(this.name);
    }
  }
  class G extends K {
    constructor(t, e, s, i, n) {
      super(t, e, s, i, n), (this.type = 5);
    }
    _$AI(t, e = this) {
      var s;
      if ((t = null !== (s = V(this, t, e, 0)) && void 0 !== s ? s : z) === j) return;
      const i = this._$AH,
        n = (t === z && i !== z) || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive,
        o = t !== z && (i === z || n);
      n && this.element.removeEventListener(this.name, this, i),
        o && this.element.addEventListener(this.name, this, t),
        (this._$AH = t);
    }
    handleEvent(t) {
      var e, s;
      'function' == typeof this._$AH
        ? this._$AH.call(
            null !== (s = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== s
              ? s
              : this.element,
            t
          )
        : this._$AH.handleEvent(t);
    }
  }
  class Q {
    constructor(t, e, s) {
      (this.element = t), (this.type = 6), (this._$AN = void 0), (this._$AM = e), (this.options = s);
    }
    get _$AU() {
      return this._$AM._$AU;
    }
    _$AI(t) {
      V(this, t);
    }
  }
  const X = y.litHtmlPolyfillSupport;
  null == X || X(I, W), (null !== (f = y.litHtmlVersions) && void 0 !== f ? f : (y.litHtmlVersions = [])).push('2.7.4');
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var Y, tt;
  class et extends _ {
    constructor() {
      super(...arguments), (this.renderOptions = { host: this }), (this._$Do = void 0);
    }
    createRenderRoot() {
      var t, e;
      const s = super.createRenderRoot();
      return (
        (null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t) || (e.renderBefore = s.firstChild), s
      );
    }
    update(t) {
      const e = this.render();
      this.hasUpdated || (this.renderOptions.isConnected = this.isConnected),
        super.update(t),
        (this._$Do = ((t, e, s) => {
          var i, n;
          const o = null !== (i = null == s ? void 0 : s.renderBefore) && void 0 !== i ? i : e;
          let r = o._$litPart$;
          if (void 0 === r) {
            const t = null !== (n = null == s ? void 0 : s.renderBefore) && void 0 !== n ? n : null;
            o._$litPart$ = r = new W(e.insertBefore(w(), t), t, void 0, null != s ? s : {});
          }
          return r._$AI(t), r;
        })(e, this.renderRoot, this.renderOptions));
    }
    connectedCallback() {
      var t;
      super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
      var t;
      super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
      return j;
    }
  }
  (et.finalized = !0),
    (et._$litElement$ = !0),
    null === (Y = globalThis.litElementHydrateSupport) || void 0 === Y || Y.call(globalThis, { LitElement: et });
  const st = globalThis.litElementPolyfillSupport;
  null == st || st({ LitElement: et }),
    (null !== (tt = globalThis.litElementVersions) && void 0 !== tt ? tt : (globalThis.litElementVersions = [])).push(
      '3.3.2'
    );
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  const it = (t, e) =>
    'method' === e.kind && e.descriptor && !('value' in e.descriptor)
      ? {
          ...e,
          finisher(s) {
            s.createProperty(e.key, t);
          }
        }
      : {
          kind: 'field',
          key: Symbol(),
          placement: 'own',
          descriptor: {},
          originalKey: e.key,
          initializer() {
            'function' == typeof e.initializer && (this[e.key] = e.initializer.call(this));
          },
          finisher(s) {
            s.createProperty(e.key, t);
          }
        };
  function nt(t) {
    return (e, s) =>
      void 0 !== s
        ? ((t, e, s) => {
            e.constructor.createProperty(s, t);
          })(t, e, s)
        : it(t, e);
    /**
     * @license
     * Copyright 2017 Google LLC
     * SPDX-License-Identifier: BSD-3-Clause
     */
  }
  /**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
  var ot;
  null === (ot = window.HTMLSlotElement) || void 0 === ot || ot.prototype.assignedElements;
  class rt extends et {
    constructor() {
      super(...arguments), (this.selectedState = 1);
    }
    set selected(t) {
      (this.selectedState = Number(t)), this.requestUpdate();
    }
    updateSelectedtab(t) {
      this.selectedState = Number(t.split('-').pop());
      const e = new CustomEvent('change', { bubbles: !0, composed: !0, detail: { value: this.selectedState } });
      this.dispatchEvent(e);
      const s = new CustomEvent('update', { bubbles: !0, composed: !0, detail: { value: this.selectedState } });
      this.dispatchEvent(s), this.requestUpdate();
    }
    get _titleSlots() {
      const t = [];
      return (
        this.querySelectorAll('[slot]').forEach((e) => {
          t.push(String(null == e ? void 0 : e.getAttribute('slot')));
        }),
        t.filter((t) => t.startsWith('tab-title-')).sort()
      );
    }
    get _contentSlots() {
      const t = [];
      return (
        this.querySelectorAll('[slot]').forEach((e) => {
          t.push(String(null == e ? void 0 : e.getAttribute('slot')));
        }),
        t.filter((t) => t.startsWith('tab-content-')).sort()
      );
    }
    firstUpdated() {
      this.requestUpdate();
    }
    renderTabs() {
      const t = this._titleSlots;
      return M`
      <ul class="nav nav-tabs">
        ${t.map(
          (t) => M`
            <li class="nav-item" @click="${() => this.updateSelectedtab(t)}">
              <a
                class="nav-link ${Number(t.split('-').pop()) === this.selectedState ? 'active' : ''}"
              >
                <slot name="${t}"></slot>
              </a>
            </li>
          `
        )}
      </ul>
    `;
    }
    renderContent() {
      const t = this._contentSlots;
      return M`
      <div class="tab-content">
        ${t.map(
          (t) => M`
            <div
              class="tab-pane ${'tab-content-' + this.selectedState === t ? 'show active' : ''}"
            >
              <slot name="${t}"></slot>
            </div>
          `
        )}
      </div>
    `;
    }
    render() {
      return M`
      ${M`
  <link
    rel="stylesheet"
    href="https://storybook.talentech.io/css/${
      (null === (t = document.querySelector('body')) || void 0 === t
      ? void 0
      : t.classList.contains('visma'))
        ? 'themes/visma/bundle.css'
        : '0.4.97/bundle.min.css'
    }"
  />
  <!-- <link rel="stylesheet" href="https://storybook.talentech.io/css/themes/visma/bundle.css" /> -->
  <link
    rel="stylesheet"
    href="https://static.talentech.io/fonts/Telegraf/talentech-telegraf.css"
  />
  <link
    rel="stylesheet"
    href="https://static.talentech.io/googlefonts/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
  />
  <link rel="stylesheet" href="https://static.talentech.io/iconfont/TIconography/style.css" />
`}
      <div class="${'true' === this.heading ? 'page-header' : ''}">
        ${this.renderTabs()} ${this.renderContent()}
      </div>
    `;
      var t;
    }
  }
  (rt.styles = [
    ((t, ...e) => {
      const s =
        1 === t.length
          ? t[0]
          : e.reduce(
              (e, s, i) =>
                e +
                ((t) => {
                  if (!0 === t._$cssResult$) return t.cssText;
                  if ('number' == typeof t) return t;
                  throw Error(
                    "Value passed to 'css' function must be a 'css' function result: " +
                      t +
                      ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security."
                  );
                })(s) +
                t[i + 1],
              t[0]
            );
      return new r(s, t, n);
    })`
      :host {
        display: block;
      }
      .page-header {
        padding: 0;
      }
      .page-header ul.nav-tabs {
        padding: 0 24px;
      }
    `
  ]),
    t(
      [nt({ type: String }), e('design:type', String), e('design:paramtypes', [String])],
      rt.prototype,
      'selected',
      null
    ),
    t([nt({ type: String }), e('design:type', String)], rt.prototype, 'heading', void 0),
    t(
      [
        (function(t) {
          return nt({ ...t, state: !0 });
        })(),
        e('design:type', Object)
      ],
      rt.prototype,
      'selectedState',
      void 0
    ),
    window.customElements.define('tabs-talentech', rt);
})();
